import styled from 'styled-components';

import { DEFAULT_DARK } from '../../styles/colors';

export const MessageScreenContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${DEFAULT_DARK};
`;

export const Message = styled.h2`
  color: white;
  margin: 5vh auto 0 auto;
`;
